import { render } from "./FixedBtns.vue?vue&type=template&id=eb68209e&scoped=true"
import script from "./FixedBtns.vue?vue&type=script&lang=js"
export * from "./FixedBtns.vue?vue&type=script&lang=js"

import "./FixedBtns.vue?vue&type=style&index=0&id=eb68209e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb68209e"]])

export default __exports__